export default __webpack_public_path__ + "locales/vi/Article.json?hash=7e128dd917d67f273891ab37e9d0c026";